var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "episodes content-section" },
    [
      _vm.filteredEpisodes.length || _vm.showEmpty
        ? [
            _c("h2", {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
            _c(
              "transition-group",
              { attrs: { name: "fade-fast" } },
              _vm._l(_vm.filteredEpisodes, function (episode, index) {
                return _c(
                  "b-card",
                  {
                    key: episode.id,
                    staticClass: "media-insert",
                    class: _vm.cardClasses(episode),
                  },
                  [
                    _c(
                      "b-media",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-media-aside",
                          [
                            _c("b-img", {
                              attrs: {
                                src: episode.thumbnail,
                                width: "128",
                                height: "96",
                              },
                            }),
                            _c("div", { staticClass: "info length" }, [
                              _vm._v(
                                _vm._s(
                                  episode.media_details.length_ - _vm.formatted
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "b-media-body",
                          [
                            _vm.labels &&
                            episode.release_number &&
                            typeof episode.release_number == "number"
                              ? _c("h5", { staticClass: "mt-0 episode-num" }, [
                                  _vm._v(
                                    "Programme " +
                                      _vm._s(episode.release_number)
                                  ),
                                ])
                              : _vm._e(),
                            _c("h5", {
                              staticClass: "mt-0",
                              domProps: {
                                innerHTML: _vm._s(episode.title.rendered),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "info row" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "views d-flex",
                                    class: { active: episode.my_xp.seen },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "dashicons dashicons-visibility",
                                    }),
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(_vm._s(episode.stats.views || 0)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "likes d-flex",
                                    class: { active: episode.my_xp.like },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "dashicons dashicons-thumbs-up",
                                    }),
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(_vm._s(episode.stats.likes || 0)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dislikes d-flex",
                                    class: { active: episode.my_xp.dislike },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "dashicons dashicons-thumbs-down",
                                    }),
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(
                                        _vm._s(episode.stats.dislikes || 0)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "favs d-flex",
                                    class: { active: episode.my_xp.fav },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "dashicons dashicons-star-filled",
                                    }),
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(_vm._s(episode.stats.favs || 0)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "comments d-flex",
                                    class: { active: episode.my_xp.comment },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "dashicons dashicons-admin-comments",
                                    }),
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(
                                        _vm._s(episode.stats.comments || 0)
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm.user && _vm.user.as && _vm.user.as.admin
                                  ? [
                                      episode.restrictions.private
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("private")]
                                          )
                                        : _vm._e(),
                                      episode.restrictions.public
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("public")]
                                          )
                                        : _vm._e(),
                                      episode.restrictions.auth
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("logged-in")]
                                          )
                                        : _vm._e(),
                                      episode.restrictions.payperview
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("payperview")]
                                          )
                                        : _vm._e(),
                                      episode.restrictions.members
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("subscribers")]
                                          )
                                        : _vm._e(),
                                      !episode.restrictions.show &&
                                      !episode.restrictions.public
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("hidden")]
                                          )
                                        : _vm._e(),
                                      episode.restrictions.premium
                                        ? _c(
                                            "div",
                                            { staticClass: "d-flex admin" },
                                            [_vm._v("premium")]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(episode.caption.rendered),
                              },
                            }),
                            _c("watch-button", { attrs: { target: episode } }),
                            episode.preview
                              ? _c(
                                  "b-btn",
                                  {
                                    staticClass: "watch watch-preview",
                                    attrs: {
                                      size: "lg",
                                      to: episode.preview,
                                      variant: "link",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.sayAction(episode, true)) +
                                        " preview"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            !_vm.filteredEpisodes.length && !_vm.hideComing
              ? _c("div", { staticClass: "message" }, [
                  _vm._v("Coming " + _vm._s(_vm.dateComing) + "!"),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }